@if(demarche){

@if (demarche.steps.length > 1 && !showMessageDemarcheCompleted) {
<mat-stepper linear="false" #stepper (selectionChange)="onStepChange($event.selectedIndex)"
  [orientation]="(stepperOrientation | async)" labelPosition="bottom"
  [ngClass]="{'hide-header': !demarche.showStepperHeader}">
  <mat-step *ngFor="let step of demarche.steps; let i = index;">
    <!-- [editable]="step.editable" [completed]="step.completed" -->
    <ng-template matStepLabel>{{step.label}}</ng-template>
    <ng-template matStepContent>
      <ng-container [ngTemplateOutlet]="typeSteps"
        [ngTemplateOutletContext]="{step: step, index: i, stepper:stepper}" />
    </ng-template>
  </mat-step>
</mat-stepper>
}

@if (demarche?.steps.length === 1 && !showMessageDemarcheCompleted) {
<ng-container [ngTemplateOutlet]="typeSteps" [ngTemplateOutletContext]="{step: demarche.steps[0]}" />
}

@if(showMessageDemarcheCompleted){
<mat-card appearance="outlined" class="card-demarche-complete">
  <mat-card-content>
    <div [innerHtml]="demarche.messageCompletedDemarche | safe"></div>
  </mat-card-content>
  <mat-card-actions class="fx-center-center fx-gap-5" style="padding-bottom: 16px;">
    @if(fromDemarchesList){
    <button mat-raised-button color="primary" routerLink="/account/demarches">
      <mat-icon style="margin-right: 5px;">add_box</mat-icon>{{'demarches.btn_nouvelle_demarche' | trans}}
    </button>
    <button mat-raised-button color="accent" routerLink="/account">
      <mat-icon style="margin-right: 5px;">account_circle</mat-icon> {{'demarches.btn_mon_compte' | trans}}
    </button>
    }@else {
    <button mat-raised-button color="accent" (click)="location.back()">
      <mat-icon style="margin-right: 5px;">arrow_back</mat-icon> {{'demarches.btn_retour' | trans}}
    </button>
    }
  </mat-card-actions>
</mat-card>
}

}@else {
<app-loader [message]="'Chargement des données...'" class="margin"></app-loader>
}

<ng-template #typeSteps let-step="step" let-index="index" let-stepper="stepper">

  @if(!demarche.showStepperHeader){
  <div style="display: flex; justify-content: space-between; align-items: center; align-content: center;">
    @if(stepper && index !== 0){<!-- && demarche?.steps[index-1]?.allowEditing -->
    <button mat-icon-button (click)="onPreviousStep(index, step)" matTooltip="Étape précédente" [disabled]="index === 0"
      style="margin-inline: 5px;" color="primary"><mat-icon>undo</mat-icon></button>
    }@else{
    <span></span>
    }
    <h2 style="text-align: center;" class="primary">{{step.label}}</h2>
    @if(demarche?.steps.length > 1){
    <button mat-stroked-button [matMenuTriggerFor]="stepMenu" style="margin-left: 5px; margin-right: 10px;"
      class="primary">
      <small><b>Étape {{index + 1}} / {{demarche?.steps.length}}</b></small>
    </button>
    <mat-menu #stepMenu="matMenu">
      @for (stepInMenu of demarche.steps; track $index; let idx = $index) {
      <button mat-menu-item (click)="goToStep(idx)" [disabled]="!stepInMenu.completed && !stepInMenu.editable"> <b>{{idx
          + 1}}</b> -
        {{stepInMenu.label}}</button>
      }
    </mat-menu>
    }@else {
    <span></span>
    }
  </div>
  }

  @if(step.infoMessage){
  <div class="card-info-container">
    <mat-card appearance="outlined" [portailCustomStyle]="step.styleCardInfo" class="card-info">
      <div [innerHtml]="step.infoMessage | safe"></div>
    </mat-card>
  </div>
  }

  @if(step.type === 'form'){
  @switch (step?.formName) {

  @case('Famille'){
  @if(stepper?.selectedIndex === index || !stepper){
  @if(permissionService.hasPermission('foyer_edit')){
  <div style="padding: 5px;"
    [ngClass]="{'show-header-stepper': !demarche.showStepperHeader, 'mat-elevation-z2': demarche.showStepperHeader}">
    <app-foyer-edit [demarcheTitle]="demarche.label" fromDemarche="true"
      (onValidate)="onValidateStepForm($event, step,index)" />
  </div>
  }@else {
  <ng-container *ngTemplateOutlet="permissionDisabled" />
  }
  }
  }

  @case('Conjoint'){
  @if(stepper?.selectedIndex === index || !stepper){
  @if(permissionService.hasPermission('foyer_edit')){
  <div style="padding: 5px;"
    [ngClass]="{'show-header-stepper': !demarche.showStepperHeader, 'mat-elevation-z2': demarche.showStepperHeader}">
    <app-conjoint-edit [demarcheTitle]="demarche.label" [idConjointFromDemarche]="step.idEntitySaved"
      fromDemarche="true" (onValidate)="onValidateStepForm($event, step,index)" />
  </div>
  }@else {
  <ng-container *ngTemplateOutlet="permissionDisabled" />
  }
  }
  }

  @case('Enfant'){
  @if(stepper?.selectedIndex === index || !stepper){
  @if(permissionService.hasPermission('child_create')){
  <div style="padding: 5px;"
    [ngClass]="{'show-header-stepper': !demarche.showStepperHeader, 'mat-elevation-z2': demarche.showStepperHeader}">
    <app-user-child-edit [demarcheTitle]="demarche.label" [idEnfantFromDemarche]="step.idEntitySaved"
      fromDemarche="true" (onValidate)="onValidateStepForm($event, step,index)" />
  </div>
  }@else {
  <ng-container *ngTemplateOutlet="permissionDisabled" />
  }
  }
  }

  @case('Pré-inscription Mikado'){
  @if(stepper?.selectedIndex === index || !stepper){
  @if(permissionService.hasPermission('preinscription_create')){
  <div style="padding: 5px;"
    [ngClass]="{'show-header-stepper': !demarche.showStepperHeader, 'mat-elevation-z2': demarche.showStepperHeader}">
    <app-user-preinscription-edit [fromDemarche]="true" [idPreinscriptionFromDemarche]="step.idEntitySaved"
      (save)="onValidateStepForm($event, step,index)" />
  </div>
  }@else {
  <ng-container *ngTemplateOutlet="permissionDisabled" />
  }
  }
  }

  @case('Inscription Diabolo'){
  @if(stepper?.selectedIndex === index || !stepper){
  @if(permissionService.hasPermission('diabolo_inscriptions_create')){
  <app-edit-diabolo-inscriptions fromDemarche="true" [usager]="currentUsager"
    [idInscriptionFromDemarche]="step.idEntitySaved" (save)="onValidateStepForm($event, step,index)" />
  }@else {
  <ng-container *ngTemplateOutlet="permissionDisabled" />
  }
  }
  }

  @case('Inscription Cogito'){
  @if(stepper?.selectedIndex === index || !stepper){
  @if(permissionService.hasPermission('cogito_inscriptions_create')){
  <app-edit-cogito-inscription fromDemarche="true" [usager]="currentUsager"
    [idInscriptionFromDemarche]="step.idEntitySaved" (save)="onValidateStepForm($event, step,index)" />
  }@else {
  <ng-container *ngTemplateOutlet="permissionDisabled" />
  }
  }
  }

  @case('Pré-inscription Lasido'){
  @if(stepper?.selectedIndex === index || !stepper){
  @if(permissionService.hasPermission('lasido_create')){
  <app-lasido-edit fromDemarche="true" [usager]="currentUsager" [idPreinscriptionFromDemarche]="step.idEntitySaved"
    (save)="onValidateStepForm($event, step,index)" />
  }@else {
  <ng-container *ngTemplateOutlet="permissionDisabled" />
  }
  }
  }

  @case('Pré-inscription Cogito'){
  @if(stepper?.selectedIndex === index || !stepper){
  @if(permissionService.hasPermission('cogito_create')){
  <app-edit-cogito-preinscription fromDemarche="true" [usager]="currentUsager"
    [idPreinscriptionFromDemarche]="step.idEntitySaved" (save)="onValidateStepForm($event, step,index)" />
  }@else {
  <ng-container *ngTemplateOutlet="permissionDisabled" />
  }
  }
  }

  }

  <!-- <ng-container *ngIf="step?.formName === 'Utilisateur'">
      <app-user-edit *ngIf="permissionService.hasPermission('account_edit'); else permissionDisabled"
        [stepForm]="step?.formStep?.stepName" [demarcheTitle]="demarche.label" fromDemarche="true"
        (onValidate)="onValidateStepForm($event, step)">
      </app-user-edit>
    </ng-container> -->

  }
  @if(step.type === 'question'){
  @if(stepper?.selectedIndex === index || !stepper){
  <app-demarche-question-step [step]="step" [index]="index" [demarche]="demarche"
    (validate)="onValidateQuestion($event, step, index)" />
  }
  }

  @if(step.type === 'select'){
  @if(stepper?.selectedIndex === index || !stepper){
  <app-demarche-select-step [demarche]="demarche" [stepper]="stepper" [step]="step" [index]="index"
    (onValidate)="saveSelectedUsager($event, step, index)" (onCreate)="addStepToCreate($event,step,index)" />
  }
  }

  @if(step.type === 'piece'){
  @if(stepper?.selectedIndex === index || !stepper){
  <app-demarche-ged [piecesAFournir]="step.docPiecesList" [entite]="step.gedEntity"
    (validate)="onValidatePieceAFournir($event,step,index)" />
  }
  }

  @if (step.type === 'document') {
  @if(stepper?.selectedIndex === index || !stepper){
  <app-ged [listPiecesAFournirFromDemarche]="step.docPiecesList"
    [entityDocumentDisplayAll]="step.entityDocumentDisplayAll" [entitiesFromDemarche]="getEntitiesBeforeStep(index)()"
    (validateStep)="onValidatePieceAFournir($event,step,index)" />
  }
  }

</ng-template>

<ng-template #resumeDialog let-data>
  <app-dialog-header title="{{'demarches.resume_dialog.title' | trans:{label : data.label} }}" noClose="true" />
  <mat-dialog-content>
    <p innerHTML="{{ 'demarches.resume_dialog.message1'|trans:{label : data.label} }}"></p>
    <p>{{ 'demarches.resume_dialog.message2'|trans:{label : data.label} }}</p>
  </mat-dialog-content>
  <mat-dialog-actions class="fx-direction-row fx-between-center">
    <button mat-raised-button [mat-dialog-close]="true" (click)="location.back()" color="accent">
      <mat-icon style="margin-right: 5px;">arrow_back</mat-icon>{{'demarches.resume_dialog.btn_retour'|trans}}
    </button>
    <div>
      <button mat-raised-button [mat-dialog-close]="true" color="primary">{{ 'demarches.resume_dialog.btn_valider'|trans
        }}</button>
      <button mat-raised-button [mat-dialog-close]="false" color="warn">{{ 'demarches.resume_dialog.btn_annuler'|trans
        }}</button>
    </div>
  </mat-dialog-actions>
</ng-template>

<ng-template #permissionDisabled>
  <h3 style="text-align: center;">{{ 'demarches.feature_disabled'|trans }}</h3>
</ng-template>
